import React, { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import bg from "../../assets/welcomeImage.jpeg";
import { CircularProgress } from "@mui/material";
import CustomPhoneInput from "components/CustomPhoneInput";

import phone from "../../assets/phoneSymbol.svg";
import email from "../../assets/EmailSymbol.svg";
import location from "../../assets/LocationSymbol.svg";

const Contact = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [phone, setPhone] = useState();
  const [phoneError, setPhoneError] = useState(true);

  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    setIsLoading(true); // Start loading

    const form = e.target;
    const name = form[0].value;
    const firstname = form[1].value;
    const email = form[2].value;
    const subject = form[3].value;
    const message = form[6].value;

    if (!email || !subject || !message || !phone || !phoneError) {
      setSnackbar({
        open: true,
        message: !phoneError
          ? "Le numéro de téléphone n'est pas valide."
          : "Merci de remplir tous les champs obligatoires.",
        severity: "error",
      });
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch("https://tourbuslive.fr/contact-form/send.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Site-Secret": process.env.REACT_APP_CONTACT_SECRET,
        },
        body: JSON.stringify({
          name: `${firstname} ${name}`,
          email,
          phone,
          subject,
          message,
        }),
      });

      const result = await res.json();

      setSnackbar({
        open: true,
        message: result.message || "Message envoyé !",
        severity: result.success ? "success" : "error",
      });

      if (result.success) form.reset();
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Erreur lors de l'envoi du message.",
        severity: "error",
      });
      console.error(err);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <div style={{ backgroundColor: "#fff", fontFamily: "Inter, sans-serif" }}>
      <header
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          padding: isSmall ? "50px 20px" : "100px 20px",
          position: "relative",
        }}
      >
        <h1
          style={{
            fontFamily: `'Sansita One', cursive`,
            fontSize: isSmall ? 40 : isMobile ? 50 : 60,
            color: "white",
            textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
            margin: 0,
          }}
        >
          Contactez-nous
        </h1>
      </header>

      <section
        style={{
          padding: isSmall ? "2em 1.5em" : "4em 2em",
          textAlign: "center",
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        <h3
          style={{
            color: "#c84653",
            fontWeight: 700,
            fontSize: isSmall ? 18 : 22,
            marginBottom: 16,
          }}
        >
          Une question ? Un devis ? Une demande particulière ?
        </h3>
        <p
          style={{
            fontSize: isSmall ? 16 : 18,
            maxWidth: 800,
            margin: "0 auto 2rem",
            color: "#333",
            lineHeight: 1.6,
          }}
        >
          Nous sommes à votre écoute ! N'hésitez pas à nous écrire via le
          formulaire ci-dessous. Nous vous répondrons avec plaisir dans les plus
          brefs délais.
        </p>

        <form
          onSubmit={handleSubmit}
          style={{
            marginTop: 30,
            display: "grid",
            gridTemplateColumns: isSmall
              ? "1fr"
              : isMobile
              ? "1fr 1fr"
              : "1fr 1fr",
            gap: 24,
            maxWidth: 900,
            marginInline: "auto",
            padding: isSmall ? "0" : "1rem",
          }}
        >
          <input type="text" placeholder="Nom" style={inputStyle} />
          <input type="text" placeholder="Prénom" style={inputStyle} />
          <input
            type="email"
            placeholder="Adresse Email *"
            style={inputStyle}
          />
          <input type="text" placeholder="Sujet *" style={inputStyle} />
          <CustomPhoneInput
            required
            value={phone}
            onChange={(newPhone) => setPhone(newPhone)}
            setPhoneError={setPhoneError}
            label="N° de téléphone"
            placeholder="Entrez votre numéro de téléphone"
            sx={{ width: "100%" }}
            contactPage
          />
          <textarea
            placeholder="Votre message *"
            rows="5"
            style={{
              ...inputStyle,
              gridColumn: "1 / -1",
              minHeight: "120px",
              resize: "vertical",
            }}
          ></textarea>
          <div
            style={{
              gridColumn: "1 / -1",
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            <button
              type="submit"
              disabled={isLoading}
              style={{
                ...buttonStyle,
                width: isSmall ? "100%" : "auto",
                opacity: isLoading ? 0.7 : 1,
                pointerEvents: isLoading ? "none" : "auto",
                position: "relative",
              }}
            >
              {isLoading ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Envoyer"
              )}
            </button>
          </div>
        </form>
      </section>

      <section
        style={{
          padding: isSmall ? "2em 1em" : "4em 2em",
          backgroundColor: "#faf7f5",
        }}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "center",
            gap: isSmall ? 20 : 30,
          }}
        >
          {[
            { label: "Téléphone", value: "06 28 12 47 74", icon: phone },
            { label: "Email", value: "tourbuslive.fr", icon: email },
            { label: "Adresse", value: "Paris, France", icon: location },
          ].map(({ label, value, icon }, index) => (
            <div
              key={index}
              style={{
                ...contactCardStyle,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                ":hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                },
              }}
            >
              <div style={iconCircle}>
                <img src={icon} alt={label} style={{ width: 24, height: 24 }} />
              </div>
              <strong
                style={{
                  fontSize: 18,
                  display: "block",
                  marginTop: 16,
                  color: "#333",
                }}
              >
                {label}
              </strong>
              <p style={{ marginTop: 10, color: "#555", fontSize: 16 }}>
                {value}
              </p>
            </div>
          ))}{" "}
        </div>
      </section>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#faf7f5",
  padding: "16px 20px",
  fontSize: 16,
  borderRadius: 8,
  border: "1px solid #ddd",
  width: "100%",
  boxSizing: "border-box",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  transition: "border-color 0.3s ease, box-shadow 0.3s ease",
  outline: "none",
  ":focus": {
    borderColor: "#c84653",
    boxShadow: "0 0 0 3px rgba(200, 70, 83, 0.2)",
  },
};

const buttonStyle = {
  backgroundColor: "#c84653",
  color: "white",
  fontWeight: 600,
  fontSize: 16,
  borderRadius: 8,
  border: "none",
  padding: "14px 36px",
  cursor: "pointer",
  boxShadow: "0 4px 6px rgba(200, 70, 83, 0.2)",
  transition:
    "background-color 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease",
  ":hover": {
    backgroundColor: "#b03848",
    transform: "translateY(-2px)",
    boxShadow: "0 6px 8px rgba(200, 70, 83, 0.3)",
  },
  ":active": {
    transform: "translateY(1px)",
    boxShadow: "0 2px 4px rgba(200, 70, 83, 0.3)",
  },
};

const contactCardStyle = {
  textAlign: "center",
  padding: 30,
  borderRadius: 12,
  backgroundColor: "#fff",
  flex: "1 1 250px",
  boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const iconCircle = {
  fontSize: 30,
  backgroundColor: "#c84653",
  color: "#fff",
  width: 60,
  height: 60,
  margin: "0 auto",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 8px rgba(200, 70, 83, 0.3)",
};

export default Contact;
